import React from "react";
import axios from "axios";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import heart from "../../assets/images/shapes/heart-2-1.png";
import welcomeImage from "../../assets/images/national-president/national-president.png";
import jciIndiaLogoImage from "../../assets/images/about/jci-india-logo.png";
import ContentLoader from "react-content-loader";

const MyLoader1 = (props) => (
  <div style={{ width: "100%", height: "100%" }}>
    <Row>
      <Col xl={12} lg={12} >
        <ContentLoader
          speed={2}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          {...props}
        >
          <rect x="-2" y="-47" rx="0" ry="0" width="595" height="271" />
        </ContentLoader>
      </Col>
    </Row>
  </div >
)

const MyLoader2 = (props) => (
  <div style={{ width: "100%", height: "100%" }}>
    <Row>
      <Col xl={12} lg={12} >
        <ContentLoader
          speed={2}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          {...props}
        >
          <circle cx="10" cy="20" r="8" />
          <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
          <circle cx="10" cy="50" r="8" />
          <rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
          <circle cx="10" cy="80" r="8" />
          <rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
          <circle cx="10" cy="110" r="8" />
          <rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
        </ContentLoader>
      </Col>
    </Row>
  </div >
)

var Api_url = process.env.GATSBY_API_URL;
console.log({ Api_url });

const axiosConfig = {
  headers: {
    "Content-Type": "application/json; text/html; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
  },
}

class AboutTwo extends React.Component {
  constructor() {
    super();
    this.state = {
      PresidentImage: {},
      PresidentMessage: {},
      PresidentLogo: {},
      Total1: 0,
      LoadingFlag1: false,
      Total2: 0,
      LoadingFlag2: false,
      Total3: 0,
      LoadingFlag3: false,
    };
  }

  getAllRecords1 = async () => {
    console.log("getAllRecords called ");
    var url = Api_url + `/api/app-settings-content`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 1,
      AppName: "jci_india_website",
      SettingsName: "np_full_image",
    };
    this.setState({ LoadingFlag1: true });
    console.log({ postData });
    // this.setState({ isLoading: true });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        var records = res.data.records;
        console.log({ records });
        var result = records.SettingsValues;
        var n1 = Object.keys(result).length;
        console.log({ n1 });
        console.log({ result });

        this.setState({ LoadingFlag1: false, PresidentImage: result, Total1: n1 });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  getAllRecords2 = async () => {
    console.log("getAllRecords called ");
    var url = Api_url + `/api/app-settings-content`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 1,
      AppName: "jci_india_website",
      SettingsName: "np_message",
    };
    this.setState({ LoadingFlag2: true });
    console.log({ postData });
    // this.setState({ isLoading: true });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        var records = res.data.records;
        console.log({ records });
        var result = records.SettingsValues;
        var n1 = Object.keys(result).length;
        console.log({ n1 });
        console.log({ result });

        this.setState({ LoadingFlag2: false, PresidentMessage: result, Total2: n1 });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  getAllRecords3 = async () => {
    console.log("getAllRecords called ");
    var url = Api_url + `/api/app-settings-content`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 1,
      AppName: "jci_india_website",
      SettingsName: "np_logo",
    };
    this.setState({ LoadingFlag3: true });
    console.log({ postData });
    // this.setState({ isLoading: true });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        var records = res.data.records;
        console.log({ records });
        var result = records.SettingsValues;
        var n1 = Object.keys(result).length;
        console.log({ n1 });
        console.log({ result });

        this.setState({ LoadingFlag3: false, PresidentLogo: result, Total3: n1 });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  componentDidMount() {
    console.log("componentDidMount called ");
    this.getAllRecords1();
    this.getAllRecords2();
    this.getAllRecords3();
  }

  render() {
    return (
      <section className="about-two pt-120 pb-120">
        <Container>
          <Row>
            <Col xl={5}>
              <div className="about-two__image">
                {this.state.LoadingFlag1 ? <MyLoader1 /> : ""}
                {this.state.LoadingFlag1
                  ? ""
                  : this.state.Total1 > 0
                    ? <img src={this.state.PresidentImage.FilePath} alt="" />
                    : ""}


                {this.state.LoadingFlag3 ? "" : ""}
                {this.state.LoadingFlag3
                  ? ""
                  : this.state.Total3 > 0
                    ?
                    <div className="about-two__award">
                      <img src={this.state.PresidentLogo.FilePath} alt="" width="160" height="160"/>
                    </div>
                    : ""}
              </div>
            </Col>
            <Col xl={7}>
              <div className="about-two__content">
                <div className="block-title">
                  <p>
                    <img src={heart} width="15" alt="" /> NATIONAL PRESIDENT
                    CORNER
                  </p>
                  <h3>{this.state.PresidentImage.SettingsValuesTitle}</h3>
                  <br />
                  <h5>National President JCI India</h5>
                </div>

                {this.state.LoadingFlag2 ? <MyLoader2 /> : ""}
                <div className="text-justify" dangerouslySetInnerHTML={{__html: this.state.PresidentMessage.SettingsValuesContent}}></div>
                <p></p>
                <Link className="thm-btn dynamic-radius" to="/about-jci-india">
                  More
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

export default AboutTwo;
